import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import {
  useFetchProfilesQuery
} from "../../store/api/apiSlice";
import { Button, Input } from "../../ui"; 

const MemberForm = () => {
  const { data: profileData, error, isLoading } = useFetchProfilesQuery();
 
  const [profile, setProfile] = useState({
    firstName: '',
    lastName: '',
    avatarName: '',
    email: '',
    phone: '',
    image: '',
    address: '',
    city: "",
    favorite_sports: [],
    interested_schools  : [], 
    
  });
  const [selectedFavoriteSports, setSelectedFavoriteSports] = useState([]);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [schools, setSchools] = useState([]);
  useEffect(() => {
    if (profileData) {
     
    const favoriteSportsRaw = profileData.user.favorite_sports?.[0];
    const interestedSchoolsRaw = profileData.user.interested_schools?.[0];

    const favoriteSports = (favoriteSportsRaw && favoriteSportsRaw !== "undefined")
      ? JSON.parse(favoriteSportsRaw)
      : [];
    
    const interestedSchools = (interestedSchoolsRaw && interestedSchoolsRaw !== "undefined")
      ? JSON.parse(interestedSchoolsRaw)
      : [];

      setProfile({
        firstName: profileData.user.firstName || "alon",
        lastName: profileData.user.lastName || "musk",
        avatarName: profileData.user.avatarName || "RebYeller",
        email: profileData.user.email || "abc@cssfa.com",
        phone: profileData.user.phone || "662-292-2327",
        image: profileData.user.image,
        favoriteSports: favoriteSports,
        interestedSchools: interestedSchools,
       

      });
      
      const initialSelectedSports = Array(3).fill(''); 
      favoriteSports.forEach((sport, index) => {
        if (index < 3) {
          initialSelectedSports[index] = sport
        }
      });
      setSelectedFavoriteSports(initialSelectedSports);
      const initialSelectedSchools = Array(3).fill('');
      interestedSchools.forEach((school, index) => {
        if (index < 3) {
          initialSelectedSchools[index] = school; 
        }
      });
      setSelectedSchools(initialSelectedSchools);
  
      localStorage.setItem("user", JSON.stringify(profileData.user.createdAt));
    }
  }, [profileData]);

  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const phoneRef = useRef();
  const addressRef = useRef();
  const schoolNameRef = useRef();
  const interestedSchoolsRef = useRef();
  const favoriteSportsRef = useRef(); 
  const referredByRef = useRef();
  const avatarRef = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const zipRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  
  const [favSports, setFavSports] = useState([]); 
  const [selectedSchool, setSelectedSchool] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [sportsOptions, setSportsOptions] = useState([[], [], []]);
 
  
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredSchools(schools.filter(school => school.name.toLowerCase().includes(value)));
  };
  const navigate = useNavigate();
  const formatPhoneNumber = (value) => {
    
    const digits = value.replace(/\D/g, '');
    
    const formatted = digits.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
    return formatted;
  };
  useEffect(() => {
    const fetchSchools = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/university/get-all`, {
          method: 'GET',
          headers: {
            'secret-key': secretKey,
            'x-auth-token': xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setSchools(data.university);
        } else {
      
        }
      } catch (error) {
   
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    const fetchFavSports = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/sports/get-all`, {
          method: 'GET',
          headers: {
            'secret-key': secretKey,
            'x-auth-token': xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setFavSports(data.sports);
          console.log("favsports",favSports)
        } else {
         
        }
      } catch (error) {
      
      }
    };

    fetchFavSports();
  }, []);

  const handleSchoolSelect = async (index, schoolId) => {
    const updatedSchools = [...selectedSchools];
    updatedSchools[index] = schoolId;
    setSelectedSchools(updatedSchools);
  
    const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/university-sports/get-single/${schoolId}`, {
        headers: {
          'secret-key': process.env.REACT_APP_SECRET_KEY,
          'x-auth-token': xAuthToken,
        },
      });
      if (response.ok) {
        const data = await response.json();
  
        const sportsList = data.universitySport.sportsID ? [data.universitySport.sportsID] : [];
  
        const updatedSportsOptions = [...sportsOptions];
        updatedSportsOptions[index] = sportsList;
        setSportsOptions(updatedSportsOptions);
      } else {
      
      }
    } catch (error) {
    
    }
  };
  

  const handleAddSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('firstName', firstNameRef.current.value);
    formData.append('lastName', lastNameRef.current.value);
    formData.append('phone', phoneRef.current.value);
    formData.append('school_name', selectedSchool);
    formData.append('favorite_sports', JSON.stringify(selectedFavoriteSports));
    
    formData.append('referredBy', referredByRef.current?.value || '');

    const address = {
      location: {
        longitude: 10,
        latitude: 110
      },
      fullAddress: addressRef.current.value,
      streetAddress: "House 1 Street 2 New York",
      city: cityRef.current.value,
      state: stateRef.current.value,
      zip: zipRef.current.value
    };
    formData.append('address', JSON.stringify(address));

    formData.append('password', passwordRef.current.value);
    formData.append('confirmPassword', confirmPasswordRef.current.value);

    if (avatarRef.current.files[0]) {
      formData.append('image', avatarRef.current.files[0]);
    }

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const response = await fetch(`${baseUrl}/api/auth/update-profile`, {
        method: 'PUT',
        headers: {
          'secret-key': secretKey,
          'x-auth-token': xAuthToken,
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        setTimeout(() => {
          window.location.reload();
      }, 10);
      
        toast.success("Profile updated successfully");
        navigate("/");
      } else {
        const errorData = await response.json();
      
      }
    } catch (error) {
     
    }
  };

  const handlePhoneChange = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    phoneRef.current.value = formattedValue;
  };

  const [image, setImage] = useState(null); 

  const handleImageChange = (event) => {
    const file = event.target.files[0]; 
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); 
      };
      reader.readAsDataURL(file); 
    }
  };
  const handleSportSelect = (index, value) => {
    const updatedSports = [...selectedFavoriteSports];
    updatedSports[index] = value;
    setSelectedFavoriteSports(updatedSports);
  };
  return (
    <div className="profileUpdateForm pt-3 pb-4" style={{ overflow: "hidden" }}>
      <div style={{ float: 'right', marginLeft: 'auto', borderRadius: "50px", paddingRight: "20px" }}>
        <Link style={{ borderRadius: "50px" }} to="/" className="btn btn-secondary ml-2 pt-1"><FontAwesomeIcon icon={faTimes} /> {/* Cross icon */}</Link>
      </div>
      <div className="title-section d-flex justify-content-center align-items-center mb-4">
        <h2 className="pb-0">Update Profile</h2>
      </div>

      <form onSubmit={handleAddSubmit} className="col-10 mx-auto ">
        <div className="profile-container" style={{ textAlign: 'center', marginTop: '50px' }}>
          <div
            className="profile-image"
            style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              backgroundColor: '#f0f0f0',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'inline-block',
              backgroundImage: `url(${image})` 
            }}
          ></div>
          <div className="button-container" style={{ marginTop: '20px' }}>
            <input
              type="file"
              id="avatar"
              ref={avatarRef}
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageChange} 
            />
            <label htmlFor="avatar" className="button change-button" style={{
              padding: '10px 20px',
              margin: '5px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              backgroundColor: '#2c3e50',
              color: 'white',
              display: 'inline-block'
            }}>
              Change picture
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between row">
          {profile.firstName && (
            <p className="fieldWrapper col-6" style={{ display: profile.firstName ? 'none' : 'block' }}>
              <Input
                placeholder="First Name"
                label="First Name"
                type="text"
                defaultValue={profile.firstName}
                ref={firstNameRef}
              />
            </p>
          )}
          <p
            className="fieldWrapper col-6"
            style={{ display: profile.lastName ? 'none' : 'block' }}
          >
            <Input
              placeholder="Last Name"
              label="Last Name"
              type="text"
              defaultValue={profile.lastName}
              ref={lastNameRef}
            />
          </p>
        </div>
        <div className="d-flex justify-content-between row" >
          <p className="fieldWrapper col-6" style={{ display: profile.lastName ? 'none' : 'block' }}>
            <Input
              placeholder="Password"
              label="Password"
              type="password"
              id="password"
              ref={passwordRef}
            />
          </p>
          <p className="fieldWrapper col-6" style={{ display: profile.lastName ? 'none' : 'block' }}>
            <Input
              placeholder="Confirm Password"
              label="Confirm Password"
              type="password"
              id="confirmPassword"
              ref={confirmPasswordRef}
            />
          </p>
        </div>

        <div className="d-flex justify-content-between row">
          <p className="fieldWrapper col-6" >
            <Input
              placeholder="Phone"
              label="Phone"
              type="tel"
              defaultValue={profile.phone}
              ref={phoneRef}
              onChange={handlePhoneChange}
            />
          </p>
          <p className="fieldWrapper col-6">
            <Input
              placeholder="Address"
              label="Address"
              type="text"
              defaultValue={profile.address}
              ref={addressRef}
            />
          </p>
        </div>

        <div className="d-flex justify-content-between row">
          <p className="fieldWrapper col-6">
            <Input
              placeholder="City"
              label="City"
              type="text"
              defaultValue={profile.city}
              ref={cityRef}
            />
          </p>
          <p className="fieldWrapper col-6">
            <Input
              placeholder="State"
              label="State"
              type="text"
              id="state"
              ref={stateRef}
            />
          </p>
        </div>

        <div className="d-flex justify-content-between row">
          <p className="fieldWrapper col-6">
            <Input
              placeholder="Zip"
              label="Zip"
              type="text"
              id="zip"
              ref={zipRef}
            />
          </p>
          <p className="fieldWrapper col-6">
            <label htmlFor="schoolName" className="form-labels">Favorite College</label>
            <select
              id="schoolName"
              ref={schoolNameRef}
              value={selectedSchool}
              onChange={(e) => setSelectedSchool(e.target.value)}
              className="form-select" style={{ height: "100%", padding: "12px", color: "gray" }}
            >
              <option value="">Select a school</option>
              {schools.map((school) => (
                <option key={school.id} value={school.name}>{school.name}</option>
              ))}
            </select>
          </p>
        </div>

        <div className="d-flex justify-content-between row">

        {[0, 1, 2].map((index) => (
  <div key={index} style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
    <div style={{ flex: 1 }}>
      <label>School {index + 1}</label>
      <select
        value={selectedSchools[index]}
        onChange={(e) => handleSchoolSelect(index, e.target.value)}
        className="form-select mb-2"
        style={{ height: "55px", padding: "12px", color: "gray" }}
      >
        <option value="">Select School</option>
        {schools.map((school) => (
                  <option key={school._id} value={school._id}>
                    {school.name}
                  </option>
                ))}
      </select>
    </div>
    <div style={{ flex: 1 }}>
      <label>Favorite Sport {index + 1}</label>
      <select
        value={selectedFavoriteSports[index]||''}
        onChange={(e) => handleSportSelect(index, e.target.value)}
        className="form-select"
        style={{ height: "55px", padding: "12px", color: "gray" }}
      >
        <option value="">Select favorite sports</option>
        {favSports.map((sport) => (
                  <option key={sport._id} value={sport.name}>
                    {sport.name}
                  </option>
                ))}
      </select>
    </div>
  </div>
))}
       
        </div>

        <div className="d-flex justify-content-between row">
          <p className="fieldWrapper col-6" style={{ display: profile.lastName ? 'none' : 'block' }}>
            <Input
              placeholder="Referred By"
              label="Referred By"
              type="text"
              id="referredBy"
              ref={referredByRef}
            />
          </p>
        </div>

        <div className="d-flex justify-content-center">
          <Button style={{ marginRight: "10px" }} type="submit" className="btn btn-primary mx-2">Update</Button>
          
        </div>
      </form>
    </div>
  );
};

export default MemberForm;
